import "./Spinner.css";

export const Spinner = ({ size = "medium", color = "#3498db" }) => {
  const sizeClass = `spinner--${size}`;

  return (
    <div
      className={`spinner ${sizeClass}`}
      style={{
        borderColor: `${color} transparent transparent transparent`,
      }}
    />
  );
};
